var initObj = {
  comment: '',
  profileComment: '',
};

export function lsProfileCommentInit() {
  localStorage.setItem('ProfileComment', JSON.stringify(initObj));
}

export function lsProfileCommentSave(comment, profileComment) {
  var obj = {
    comment: '',
    profileComment: '',
  };
  localStorage.setItem('ProfileComment', JSON.stringify(obj));
}

export function lsProfileCommentInitCheck() {
  let lsObj = JSON.parse(localStorage.getItem('ProfileComment'));

  if (JSON.stringify(initObj) === JSON.stringify(lsObj)) {
    return true;
  }
  else {
    return false;
  }
}
